package com.eladfinish.bible.contest.screens.main.ui.dialogs

import androidx.compose.foundation.background
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.heightIn
import androidx.compose.foundation.text.selection.SelectionContainer
import androidx.compose.material3.CardDefaults
import androidx.compose.material3.ExperimentalMaterial3Api
import androidx.compose.material3.OutlinedCard
import androidx.compose.material3.ShapeDefaults
import androidx.compose.runtime.Composable
import androidx.compose.ui.Modifier
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.unit.dp
import androidx.compose.ui.window.Dialog
import androidx.compose.ui.window.DialogProperties
import com.eladfinish.bible.contest.ui.components.dialogs.CustomTitle
import com.eladfinish.bible.contest.ui.components.dialogs.DialogPositiveButtonInColumn
import com.eladfinish.bible.contest.ui.components.verticalScrollWithScrollbar
import dev.icerock.moko.resources.StringResource
import dev.icerock.moko.resources.compose.stringResource

@OptIn(ExperimentalMaterial3Api::class)
@Composable
internal fun MainScreenDialogContainer(
    titleResource: StringResource,
    onDismiss: () -> Unit,
    content: @Composable () -> Unit,
) {

    Dialog(
        onDismissRequest = {
            onDismiss.invoke()
        },
        properties = DialogProperties(
            dismissOnBackPress = true,
            dismissOnClickOutside = true,
        ),
    ) {
        OutlinedCard(
            modifier = Modifier
                .heightIn(300.dp, 600.dp),
            shape = ShapeDefaults.Medium,
            colors = CardDefaults.elevatedCardColors(),
            elevation = CardDefaults.elevatedCardElevation(),
            content = {
                CustomTitle(
                    text = stringResource(resource = titleResource),
                )

                Column(
                    modifier = Modifier
                        .weight(1f)
                        .fillMaxWidth()
                        .background(Color.White)
                        .verticalScrollWithScrollbar(),
                ) {
                    SelectionContainer {
                        content()
                    }
                }

                DialogPositiveButtonInColumn(onClick = onDismiss)
            }
        )
    }
}
